import "./style.css";
import Logo from "../../images/Hero/logo.png";
import whatsappicon from "../../images/Hero/whatsapp.png";

export default function Hero(){
  return(
    <div className="hero">
    <div className="hero-container">
      <div className="hero-logo">
        <img src={Logo} alt="Logo Sanches Profissional"/>
      </div>
      <div className="hero-text">
        <h2>
          Transforme-se em uma <span>referência</span><br/>
          da área da beleza!
          {/* Torne-se o profissional mais<br/>
          valorizado da sua<span> cidade</span> ! */}
        </h2>
        <p>
          Uma mentoria de transformação completa para <br/>
          profissionais da beleza que querem agenda cheia<br/> 
          e liberdade financeira
        </p>
      </div>
      <div className="hero-image">
        {/* <img src={Sanches} alt="Wilson Sanches"/> */}
        <iframe 
          src="https://player.vimeo.com/video/1090550706?h=813b8574f8&dnt=1" 
          title="Vídeo de apresentação"
          width="100%" 
          height="420" 
          frameborder="0"
          allowfullscreen
        />
      </div>
      <div className="hero-button">
        <a href="#sell">
          <button className="shadow__btn">
            Quero ser quem sempre sonhei
          </button>
        </a>
      </div>
      <div className='whatsapp'>
        <a href='https://wa.me/5519991707383' target='_blank' rel='noreferrer'>
          <img src={whatsappicon} alt='whatsapp'/>
        </a>
      </div>
    </div>
    </div>
  );
};